export default "__VITE_ASSET__sIkMm$yP__"